import * as actionTypes from "./actionTypes";
import axios from "axios";
import * as applicationUrl from "../../config/actionUrl";
import * as errorMsg from '../../config/errorMsg';

export const resetUserStore = () => {
  return {
    type: actionTypes.RESET_USER_STORE,
  };
};

export const showUserGenHistoryFail = (error) => {
  return {
    type: actionTypes.SHOW_USER_GENERATION_HISTORY_FAIL,
    error: error.debugMessage,
  };
};

export const showUserGenHistorySuccess = (files) => {
  return {
    type: actionTypes.SHOW_USER_GENERATION_HISTORY_SUCCESS,
    files: files,
  };
};

export const showUserGenHistoryStart = () => {
  return {
    type: actionTypes.SHOW_USER_GENERATION_HISTORY_START,
  };
};

export const showUserGenHistory = () => {
  return async (dispatch) => {
    let formData = {
      email: localStorage.getItem("username"),
    };
    dispatch(showUserGenHistoryStart());
    axios
      .post(applicationUrl.SHOW_GENERATE_HISTORY, formData, {
        headers: {
          "Content-Type": "application/json",
        },
        mode: "cors",
        withCredentials: true,
      })
      .then(res => {
        if(res.data.ProductResponse.message ===  errorMsg.EMPTY_HISTORY){
          dispatch(showUserGenHistorySuccess([]));
        }
        else if (res.data.ProductResponse.message !==  errorMsg.EMPTY_HISTORY){
          dispatch(showUserGenHistorySuccess(res.data.ProductResponse.response));
        }
        
      })
      .catch((err) => {
        dispatch(
          showUserGenHistoryFail(err.response.data.producterrorresponse)
        );
      });
  };
};
